import { iconList } from "@/lib/get-icon";
import { Component } from "@builder.io/sdk";

export const benefitsConfig: Component = {
  name: "Benefits",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "benefits",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "The Care Indeed Advantage",
      helperText: "Main heading for the section",
    },
    {
      name: "description",
      type: "longText",
      friendlyName: "Subheading",
      defaultValue: "Benefits of making Care Indeed your partner",
      helperText: "Subheading for the section",
    },
    {
      name: "backgroundColor",
      type: "string",
      enum: ["light-orange", "white"],
      defaultValue: "light-orange",
      helperText: "Background color for the section",
    },
    {
      name: "items",
      type: "list",
      friendlyName: "Benefits",
      helperText: "Benefits to display in the section",
      onChange: (options) => {
        if (options.get("items").length > 3) {
          options.set("items", options.get("items").slice(0, 3));
          alert("You can only add up to 3 cards");
        }
      },
      subFields: [
        {
          name: "title",
          type: "string",
          required: true,
          helperText: "Title of the benefit",
        },
        {
          name: "description",
          type: "string",
          required: true,
          helperText: "Description of the benefit",
        },
        {
          name: "icon",
          type: "string",
          enum: iconList,
          required: true,
          helperText: "Icon to display for the benefit",
          defaultValue: "enhanced-quality-of-life",
        },
      ],
      defaultValue: [
        {
          title: "Enhanced Quality of Life",
          description:
            "Our comprehensive services promote physical, mental, and emotional well-being for you or your loved one.",
          icon: "enhanced-quality-of-life",
        },
        {
          title: "24/7 Client Support",
          description:
            "We offer round-the-clock support, providing continuous peace of mind and immediate help whenever needed.",
          icon: "staff-coordinator-24-7",
        },
        {
          title: "Highly Trained Professionals",
          description:
            "Our healthcare professionals are well-trained and educated, ensuring the highest standard of care for your loved ones.",
          icon: "employee-model",
        },
      ],
    },
  ],
};
